<template>
  <div class="app-container">
    <TopHeader title="充值结果"></TopHeader>
    <div class="content">
      <img
        v-if="isSuccess"
        src="@/assets/images/pay-success.png"
        alt=""
        srcset=""
      />
      <img v-else src="@/assets/images/pay-failed.png" alt="" srcset="" />

      <div v-if="isSuccess" class="title success">充值成功</div>
      <div v-else class="title fail">充值失败:{{ res.message }}</div>
      <div class="amount">金额：¥{{ amount }}</div>

      <van-button
        class="button"
        @click="
          $router.push({
            name: 'Home'
          })
        "
      >
        返回首页（{{ countdown }}s）
      </van-button>
    </div>
  </div>
</template>

<script>
import TopHeader from '@/components/topHeader/index.vue';

export default {
  name: 'RechargeResult',
  components: { TopHeader },
  data() {
    return {
      isSuccess: false,
      countdown: 10, // 倒计时秒数
      timer: null, // 定时器
      res: {}
    };
  },
  created() {
    this.res = JSON.parse(this.$route.query.result);
    this.amount = this.$route.query.amount;
    this.isSuccess = this.res.code === 0;

    // 页面创建时开始倒计时
    this.startCountdown();
  },
  mounted() {
    // 可以在这里添加其他初始化逻辑
  },
  beforeDestroy() {
    // 组件销毁前清除定时器，防止内存泄漏
    this.clearTimer();
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
        } else {
          this.goToHome();
        }
      }, 1000);
    },
    goToHome() {
      // 清除定时器
      this.clearTimer();
      // 跳转到首页
      this.$router.push({
        name: 'Home'
      });
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .content {
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 198.82px;
      height: 152px;
      margin-top: 60px;
    }
    .title {
      font-size: 28px;
      font-weight: 700;
      font-family: 'PingFang SC';
      margin-top: 70px;
    }
    .success {
      color: #00b42a;
    }
    .fail {
      color: #c7000b;
      text-align: center;
    }
    .amount {
      color: #333333;
      font-size: 16px;
      font-weight: 500;
      margin: 20px 0 90px 0;
    }
    .button {
      width: 343px;
      height: 44px;
      border-radius: 25px;
      opacity: 1;
      background: #fa5050;
      box-shadow: 0 0 20px 0 #fa505040;
      color: #ffffff;
      font-size: 18px;
      font-weight: 500;
      font-family: 'PingFang SC';
    }
  }
}
</style>
